<ng-container *transloco="let t; prefix: 'group-management.panels.past-participants'">
  <app-panel-body>
    <div class="flex min-h-0 flex-1 flex-col text-sm text-primary-text">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <p>{{ t('instruction') }}</p>

            @if (loading()) {
              <p class="text-secondary-text">{{ t('loading') }}</p>
            } @else if (loadError()) {
              <p class="text-danger" role="alert">{{ t('load-error') }}</p>
            } @else if (pastParticipants().length === 0) {
              <p class="text-secondary-text">{{ t('empty') }}</p>
            } @else {
              <div class="mb-3 flex flex-wrap gap-2">
                <button
                  type="button"
                  class="rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
                  (click)="selectAll()"
                >
                  {{ t('select-all') }}
                </button>
                <button
                  type="button"
                  class="rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
                  (click)="selectNone()"
                >
                  {{ t('select-none') }}
                </button>
              </div>

              <ul class="divide-y divide-primary-border rounded-md border border-primary-border">
                @for (person of pastParticipants(); track person.id) {
                  <li class="flex items-start gap-3 px-3 py-3">
                    <input
                      type="checkbox"
                      class="mt-1"
                      [checked]="isSelected(person.id)"
                      (change)="toggleSelection(person.id)"
                      [attr.aria-label]="t('select-person', { name: person.firstname + ' ' + person.lastname })"
                    />
                    <div>
                      <p class="font-semibold">{{ person.firstname }} {{ person.lastname }}</p>
                      <p class="text-secondary-text">{{ person.email }}</p>
                    </div>
                  </li>
                }
              </ul>
            }
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 flex-col gap-3 border-t border-primary-border px-4 py-4">
        <button
          type="button"
          class="w-full rounded-md bg-teal px-4 py-2 text-sm font-semibold text-white hover:bg-teal-600 disabled:opacity-50"
          [disabled]="submitting() || selectedIds().size === 0"
          (click)="submit()"
        >
          {{ t('add-selected', { count: selectedIds().size }) }}
        </button>
        <button
          type="button"
          class="w-full rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
          (click)="cancel()"
          [disabled]="submitting()"
        >
          {{ t('close') }}
        </button>
      </div>
    </div>
  </app-panel-body>
</ng-container>
